/**
 * Adzuki
 * google_places_search.js
 */

(function GooglePlaces($, Adzuki)
{
	"use strict";

	// selectors used for instantiating this must be unique.
	// unfortunately, there's no way to reliably get the selector used to create
	// a jQuery object, so i'm only tracking string-based selectors.
	var selectors = [];

	var places = function GooglePlaces(el)
	{
		var $el,
		    $input_field,
		    postdata = {},
		    search_type,
		    include_types;

		try
		{
			if (el instanceof jQuery) {
				$el = el;
			}
			else {
				if (selectors.indexOf(el) === -1) {
					selectors.push(el);
				}
				else {
					console.warn('[Adzuki.GooglePlacesSearch] potential duplicate selector detected:', el);
				}

				$el = $(el);
			}

			$input_field  = $el.find('input[type="text"]');
			search_type   = $el.data('search-type');
			include_types = $el.data('include');

			if (!$input_field.length) {
				throw new Error('Cannot find input field.');
			}

			postdata = {
				type: search_type
			};

			if (include_types) {
				postdata.include = include_types;
			}
		}
		catch (err) {
			console.error('[Adzuki.GooglePlacesSearch]', err);
			return;
		}

		Adzuki.Typeahead(
			$input_field,
			function search(term, display, $self)
			{
				postdata.term = term;

				Adzuki.Ajax.post('/Searches/google', postdata)
				.then(function searchResults(places)
				{
					$self.removeClass('ajax-spinner');
					display(places.results || [{name: places.message}]);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for places."}]);
				});
			},
			function select(item, $self)
			{
				if (!item.place_id && !include_types) {
					return;
				}

				if (item.place_id)
				{
					$self.addClass('ajax-spinner').prop('disabled', true);

					Adzuki.Ajax.post('/Searches/google', {
						type    : 'coordinateData',
						place_id: item.place_id
					})
					.then(function selectResults(location)
					{
						if (location.status) {
							populateInputs($self, location.results);
						}

						$self.removeClass('ajax-spinner').prop('disabled', false);
						$self.trigger('gp.selected', [item, location.results]);
					});
				}
				else {
					populateInputs($self, item);
					$self.trigger('gp.selected', [item]);
				}
			},
			function template(item) {
				if (item.vicinity) {
					item.name = item.name+', '+item.vicinity;
				}
				return JSON.stringify(item);
			}
		);

		$input_field.on('click', function focused() {
			clearInputs(this);
		});

		function populateInputs($input, location)
		{
			var $inputs = $input.parents('.google-places').find('input').not($input_field),
			    _$input;

			$.each($inputs, function _populateInput(i, input) {
				_$input = $(input);
				_$input.val(location[_$input.attr('class')]);
			});
		}

		function clearInputs(el)
		{
			$(el).val('');
		}
	};

	Adzuki.GooglePlaces = places;
}(jQuery, window.Adzuki || {}));
